import React from 'react';
import Icon from '../../../components/AppIcon';

const PriceDisplay = ({ price, route, pickupDistrict, destinationDistrict, basePrice }) => {
  return (
    <div className="morphic-card p-4 bg-gradient-to-br from-accent/10 to-accent/5 border-accent/20">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="DollarSign" size={20} className="text-accent" />
            <h3 className="font-semibold text-foreground">Price</h3>
          </div>
          
          {pickupDistrict && destinationDistrict && (
            <p className="text-sm text-muted-foreground mb-2">
              {pickupDistrict} → {destinationDistrict}
            </p>
          )}
          
          {route && (
            <p className="text-xs text-muted-foreground">
              {route}
            </p>
          )}
          
          {basePrice > 0 && (
            <p className="text-xs text-muted-foreground mt-1">
              Base fare: {basePrice} THB (before service multiplier)
            </p>
          )}
        </div>
        
        <div className="text-right">
          <div className="text-3xl font-bold text-accent">
            {price}
          </div>
          <div className="text-sm text-muted-foreground">THB</div>
        </div>
      </div>
      
    </div>
  );
};

export default PriceDisplay;